/**
 * @SAGA : Redux Saga middleware for side effects. Help for Redux async call.
 * @Logger : Logs Previous state, action and next state in the browser console.
 */

/*** Importing all dependencies ***/
import {applyMiddleware, combineReducers, compose, createStore} from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './RootSaga';
import yearMakeModelReducer from "./YearMakeModelReducer";
import dealerReducer from "./DealerReducer";
import searchResultReducer from "./SearchResultReducer"
import cartReducer from "./CartReducer";
import appParamsReducer from "./AppParamsReducer";

/*** create the Saga Middleware ***/
const sagaMiddleware = createSagaMiddleware();

let middleware = [sagaMiddleware];

/** The combineReducers helper function turns an object whose values are different
 reducing functions into a single reducing function you can pass to createStore **/
export const rootReducer = combineReducers({
    appParamsReducer: appParamsReducer,
    yearMakeModelReducer: yearMakeModelReducer,
    dealerReducer: dealerReducer,
    searchResultReducer: searchResultReducer,
    cartReducer: cartReducer,
});

/*** Enable Redux-Logger and @Enhancers only on dev mode **/
let store;
const env = process.env.NODE_ENV;

if (env === 'development') {
    let reduxLogger = require('redux-logger');
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    const loggerMiddleware = reduxLogger.createLogger();
    middleware.push(loggerMiddleware);
    store = createStore(rootReducer, composeEnhancers(applyMiddleware(...middleware)));
} else {
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    store = createStore(rootReducer, composeEnhancers(applyMiddleware(...middleware)));
}

/** run the saga **/
sagaMiddleware.run(rootSaga);

export default store;
